import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AppLayout from './App';
import HomePage from './components/HomePage';
import ProductsShowcase from './components/ProductsShowcase';
import MasterclassPage from './components/MasterclassPage';
import ConsultingPage from './components/ConsultingPage';
import AdminLogin from './components/AdminLogin';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { PremiumModalProvider } from './contexts/PremiumModalContext';

// Old routes — commented out during revamp
// import ProjectsPage from './components/ProjectsPage';
// import LessonPlanGenerator from './components/LessonPlanGenerator';
// import LessonPlanPage from './components/LessonPlanPage';
// import LessonPlansDashboard from './components/LessonPlansDashboard';
// import AudioPlayerPage from './components/AudioPlayerPage';
// import VideoPlayerPage from './components/VideoPlayerPage';

const AppRouter: React.FC = () => {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <NotificationProvider>
          <PremiumModalProvider>
            <AppLayout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/products" element={<ProductsShowcase />} />
                <Route path="/masterclass" element={<MasterclassPage />} />
                <Route path="/consulting" element={<ConsultingPage />} />
                <Route path="/admin" element={<AdminLogin />} />

                {/* Redirect old routes */}
                <Route path="/projects" element={<Navigate to="/products" replace />} />

                {/* Old routes — commented out during revamp */}
                {/* <Route path="/lesson-plan" element={<LessonPlanGenerator />} /> */}
                {/* <Route path="/dashboard" element={<LessonPlansDashboard />} /> */}
                {/* <Route path="/plan/:planId" element={<LessonPlanPage />} /> */}
                {/* <Route path="/audio-player" element={<AudioPlayerPage />} /> */}
                {/* <Route path="/video-player" element={<VideoPlayerPage />} /> */}
              </Routes>
            </AppLayout>
          </PremiumModalProvider>
        </NotificationProvider>
      </AuthProvider>
    </Router>
  );
};

export default AppRouter;
